var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[_c('Title',{staticClass:"mb-2",attrs:{"text":"Scheduled Tournaments (Monthly)"}}),_c('Calendar'),_c('hr',{staticClass:"my-4 border-0 bg-secondary",staticStyle:{"height":"1px"}}),_c('UserActivitySection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }